import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const QueryParamListener = () => {
  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    // Example: Log query params globally
    console.log('Query Params:', Object.fromEntries(params.entries()));

    // Or store globally in a state management system like Redux or Context
    // dispatch(setQueryParams(Object.fromEntries(params.entries())));

  }, [location.search]);

  return null; // No UI
};

export default QueryParamListener;
